import {
  type FunctionalComponent, h
} from '@stencil/core';

export interface SearchableFacetProps{
  inputValue: string,
  inputLabel: string,
  placeholder: string,
  onKeyPress: CallableFunction,
  inputChanged: CallableFunction
}

export const SearchableFacet:FunctionalComponent<SearchableFacetProps> = (props) => {
    const {inputValue, inputLabel, placeholder, onKeyPress, inputChanged } = props;

    return <div>
      {inputLabel ? <label class="search-facet-input-label">{inputLabel}</label> : ''}
      <input
        type="text"
        placeholder={placeholder}
        class="search-facet-input"
        onInput={(e) => inputChanged((e.currentTarget as HTMLInputElement).value)}
        onKeyPress={(e) => onKeyPress(e, (e.currentTarget as HTMLInputElement).value)}
        value={inputValue}
      />
      <span>
        {inputValue ?
          <se-icon
            id="se_globalsearch_icon"
            size="nano"
            class="search-facet-input-icon-close"
            onClick={() => inputChanged('')}
          >
            action_close
          </se-icon>
          :
          <se-icon
            id="se_globalsearch_icon"
            size="small"
            class="search-facet-input-icon"
          >
            action_search_stroke
          </se-icon>
        }
      </span>
    </div>;
};
